import { jsx, jsxs } from "react/jsx-runtime";
import { Slider } from "@base-ui/react/slider";
import { useCallback, useMemo } from "react";
import { cn } from "../../utils/cn.js";
import { sliderVariants } from "./Slider.variants.js";
import { SliderHistogram } from "./SliderHistogram.js";
import { SliderMark } from "./SliderMark.js";
function Slider_Slider({ labelText = '', showValueText = false, emphasis = 'regular', name = '', ariaLabelledby, disabled, step = 1, min = 0, max = 100, value, defaultValue, handleChange, currencyHelperText = '', currencySymbol = '', valueSuffix = '', marks = [], slotClassNames = {}, histogram }) {
    const hasHistogram = !!histogram && histogram.counts.length > 0 && histogram.binWidth > 0;
    const { root, label, valueText, control, track, indicator, thumb, marks: marksSlot } = sliderVariants({
        emphasis,
        hasHistogram
    });
    const { rootClass = '', labelClass = '', valueTextClass = '', indicatorClass = '', controlClass = '', trackClass = '', thumbClass = '', marksClass = '', histogramContainerClass = '' } = slotClassNames;
    const v = value || defaultValue;
    const rootClasses = cn(root(), rootClass);
    const labelClasses = cn(label(), labelClass);
    const valueTextClasses = cn(valueText(), valueTextClass);
    const controlClasses = cn(control(), controlClass);
    const trackClasses = cn(track(), trackClass);
    const indicatorClasses = cn(indicator(), indicatorClass);
    const thumbClasses = cn(thumb(), thumbClass);
    const marksClasses = cn(marksSlot(), marksClass);
    const rangeValues = Array.isArray(v) && 2 === v.length ? [
        v[0],
        v[1]
    ] : null;
    const onValueChangeCallback = useCallback((value, eventDetails)=>{
        handleChange?.(value, eventDetails?.event);
    }, [
        handleChange
    ]);
    const markPositions = useMemo(()=>marks.map((mark)=>({
                ...mark,
                value: mark.value / max * 100
            })), [
        marks,
        max
    ]);
    return /*#__PURE__*/ jsxs(Slider.Root, {
        className: rootClasses,
        "data-testid": "root",
        name: name,
        "aria-labelledby": ariaLabelledby,
        defaultValue: defaultValue,
        disabled: disabled,
        step: step,
        min: min,
        max: max,
        value: value,
        onValueChange: onValueChangeCallback,
        children: [
            /*#__PURE__*/ jsxs("div", {
                className: "flex h-5 justify-between",
                children: [
                    /*#__PURE__*/ jsx("div", {
                        id: ariaLabelledby,
                        "data-testid": "label",
                        className: labelClasses,
                        children: labelText
                    }),
                    showValueText ? /*#__PURE__*/ jsxs("div", {
                        "data-testid": "value",
                        className: valueTextClasses,
                        children: [
                            currencyHelperText,
                            " ",
                            currencySymbol,
                            /*#__PURE__*/ jsx(Slider.Value, {}),
                            valueSuffix
                        ]
                    }) : null
                ]
            }),
            hasHistogram && /*#__PURE__*/ jsx(SliderHistogram, {
                histogram: histogram,
                min: min,
                rangeValues: rangeValues,
                emphasis: emphasis,
                containerClass: histogramContainerClass
            }),
            /*#__PURE__*/ jsx(Slider.Control, {
                "data-testid": "control",
                className: controlClasses,
                children: /*#__PURE__*/ jsxs(Slider.Track, {
                    "data-testid": "track",
                    className: trackClasses,
                    children: [
                        /*#__PURE__*/ jsx(Slider.Indicator, {
                            "data-testid": "indicator",
                            className: indicatorClasses
                        }),
                        marks?.length > 0 && /*#__PURE__*/ jsx("div", {
                            className: marksClasses,
                            "data-testid": "marks",
                            children: markPositions.map((mark)=>/*#__PURE__*/ jsx(SliderMark, {
                                    label: mark.label,
                                    value: mark.value
                                }, `mark-${mark.label}`))
                        }),
                        v && Array.isArray(v) ? v.map((_, i)=>/*#__PURE__*/ jsx(Slider.Thumb, {
                                className: thumbClasses
                            }, `thumb-${i}`)) : /*#__PURE__*/ jsx(Slider.Thumb, {
                            className: thumbClasses
                        })
                    ]
                })
            })
        ]
    });
}
export { Slider_Slider as Slider };
